<hb-modal-dialog heading="Reset password" [okDisabled]="!okDisabled">
  <div content class="form-container">
    <div class="form-group row">
      <hb-password-reset [showContinue]="false" (resetSuccessful)="setOkDisabled($event)"></hb-password-reset>
    </div>
  </div>
</hb-modal-dialog>